export default __webpack_public_path__ + "static/media/share.8a55227a.svg";